import { InstructionComponentProps } from "../InstructionComponent"
import ImageTextComponent from "../../ImageTextComponent"

import IMG_1 from "../../../resources/tutorial/DOOR_IOS_4.png"
import IMG_2 from "../../../resources/tutorial/DOOR_IOS_5.png"
import IMG_3 from "../../../resources/tutorial/DOOR_IOS_6.png"
import IMG_4 from "../../../resources/tutorial/DOOR_IOS_7.png"
import IMG_5 from "../../../resources/tutorial/Questionnaire_Step5.png"
import IMG_6 from "../../../resources/tutorial/Questionnaire_Step6.png"

const AppQuestionnaireInstructions: InstructionComponentProps = {
    name: "Wie fülle ich den PHQ-8 und SFQ-4 Fragebogen aus?",
    path: "/help/patient/questionnaire",
    description:
        "Der Ausfüllprozess ist für alle Fragebögen identisch. Hier wird der Ablauf am Beispiel des PHQ-8 Fragebogens gezeigt.",
    both: [
        <ImageTextComponent
            text={
                <>
                    Navigieren Sie auf die Startseite, sodass die Kacheln mit
                    den Fragebögen angezeigt werden. Klicken Sie nun auf den
                    Knopf mit &#34;Jetzt ausfüllen&#34;.
                </>
            }
            images={[IMG_1]}
        />,
        <ImageTextComponent
            text={
                <>
                    Sie können nun die Fragen beantworten. 
                    Am Ende sehen Sie eine Übersicht Ihrer Antworten. Sollte
                    eine Antwort fehlen oder falsch sein, können Sie durch einen
                    Klick auf die Frage zurückgehen und die Antwort ändern.
                    Fehlende Antworten sind rot markiert. Sind alle Fragen
                    beantwortet, klicken Sie auf den grünen &#34;Fragebogen
                    abschicken&#34; Knopf.
                </>
            }
            images={[IMG_2,IMG_3]}
        />,
        <ImageTextComponent
            text={
                <>
                    Nach dem erfolgreichen Abschicken des Fragebogens, wird Ihnen in der Kachel nun angezeigt, wann Sie den Fragebogen zuletzt ausgefüllt haben. 
                </>
            }
            images={[, IMG_4]}
        />
    ]
}

export default AppQuestionnaireInstructions
